<template>
  <div class="page">
    <nav-bar />
    <div class="page-wrapper">
      <div class="events">
        <div class="events__main">
          <div class="page-nav">
            <h2 class="page-nav__title">Шаг 3</h2>
            <a class="page-nav__link" @click="checkAndBack">Компоненты </a>
            <p class="page-nav__current">/ Личные достижения</p>
          </div>
          <h1 class="events__title">Личные достижения</h1>
          <div class="events__list">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="events__item"
            >
              <CCheckbox :label="item.name" v-model="item.enabled"></CCheckbox>
            </div>
          </div>
        </div>
        <div class="events__buttons">
          <button class="events__back" @click="checkAndBack">
            <svg-icon type="back" />
            Назад
          </button>
          <button class="events__save" @click="save()">
            Сохранить
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CCheckbox from "../../components/forms/CCheckbox";
import { mapGetters } from "vuex";
export default {
  name: "Events",
  components: { CCheckbox },

  data() {
    let items = [
      {
        name: "Бизнес-мама",
        enabled: false,
        type: "buisness-mama",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Бизнес-тренер",
        enabled: false,
        type: "buisness-coach",
        visibleFor: ["abo", "kz", "allstar", "abo_meeting"]
      },
      {
        name: "Бьюти-блогер",
        enabled: false,
        type: "beauty-blogger",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      // {
      //   name: "Врач-диетолог",
      //   enabled: false,
      //   type: "doctor-diet"
      // },
      {
        name: "Квалифицированный фитнес-тренер",
        enabled: false,
        type: "fitness-coach",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Опытный кулинар",
        enabled: false,
        type: "cook-expert",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Профессионал c высшим образованием",
        enabled: false,
        type: "1edu",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Профессионал c двумя высшими образованиями",
        enabled: false,
        type: "2edu",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Профессиональный визажист",
        enabled: false,
        type: "pro-hairstyle",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Специалист в категории “Amway Мама”",
        enabled: false,
        type: "specialist-amway-mama",
        visibleFor: ["abo", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Специалист в категории “Дом”",
        enabled: false,
        type: "specialist-house",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Специалист в категории “Здоровье”",
        enabled: false,
        type: "specialist-health",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      },
      {
        name: "Специалист в категории “Красота”",
        enabled: false,
        type: "specialist-beauty",
        visibleFor: ["abo", "kz", "vip", "allstar", "abo_meeting"]
      }
    ];
    items = items.filter(i => {
      let enabled = false;
      this.$store.state.user.user_type.forEach(t => {
        enabled = enabled || i.visibleFor.includes(t.code);
      });
      if (this.$store.state.isKZ) {
        if (!i.visibleFor.includes("kz")) {
          enabled = false;
        }
      }
      return enabled;
    });
    return {
      items
    };
  },

  computed: {
    ...mapGetters(["getComponentByName"])
  },

  methods: {
    save() {
      if (this.items.filter(i => i.enabled).length < 2) {
        return this.$eventBus.$emit("showError", {
          error: "Выберите минимум два достижения"
        });
      }
      const enabled = this.items.filter(c => c.enabled).length !== 0;
      const saveToVuexAndServer = () => {
        return this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("Achievements").id,
          content: Object.assign(
            {},
            {
              items: this.items
                .filter(i => i.enabled)
                .map(i => {
                  delete i.visibleFor;
                  return i;
                })
            }
          ),
          enabled
        });
      };
      saveToVuexAndServer();
      this.GAEvent(
        "step_3-choose-personal-skills",
        "chosen-personal-skills",
        this.items
          .filter(c => c.enabled)
          .map(c => c.name)
          .join(",")
      );
    },
    checkAndBack() {
      if (!this.items.filter(i => i.enabled).length) {
        this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("Achievements").id,
          content: Object.assign(
            {},
            {
              items: this.items
                .filter(i => i.enabled)
                .map(i => {
                  delete i.visibleFor;
                  return i;
                })
            }
          ),
          enabled: false
        });
      }
      this.$router.go(-1);
      this.GAEvent("step_3-choose-personal-skills_back");
    },
    fillModalFromState() {
      if (this.getComponentByName("Achievements")) {
        this.content = Object.assign(
          {},
          this.getComponentByName("Achievements").content
        );
        if (this.content.items) {
          this.content.items.forEach((item, index) => {
            if (this.items[index]) {
              this.items[index].enabled = item.enabled;
            }
          });
        }
      }
    }
  },
  mounted() {
    this.fillModalFromState();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }

  &-wrapper {
    max-width: 100%;
    display: flex;
    justify-content: center;
    @media #{$tablet} {
      margin: 0;
      padding: 0;
    }
  }
}

.events {
  width: 100%;
  max-width: 1200px;
  background: #f4f4f4;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
  }

  * {
    font-family: "Inter", sans-serif;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    text-align: left;
    margin: 0 0 60px;
    padding: 0;
    @media #{$mobile} {
      font-size: 34px;
      margin: 0 0 30px;
      padding: 0 15px;
    }
  }

  &__main {
    padding: 60px 70px;
    @media #{$tablet} {
      padding: 30px;
    }
    @media #{$mobile} {
      padding: 30px 0;
    }
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
  }

  &__item {
    width: calc(100% / 3);
    margin-bottom: 45px;

    @media #{$tablet} {
      width: calc(100% / 2);
    }

    @media #{$mobile} {
      width: 100%;
      margin-bottom: 5px;
    }
  }

  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__back {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 30px;
    }

    span {
      margin-right: 10px;
    }
  }

  &__save {
    border-radius: 5px;
    border: none;
    background: #3a5eec;
    color: #ffffff;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    padding: 15px 40px;
    @media #{$mobile} {
      margin-bottom: 30px;
    }
  }
}
</style>
